import {
  Suspense, useCallback,
} from 'react';
import {
  Navigate,
  Route, Routes,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import { accessSelector, userSelector } from 'store/auth/authSelectors';
import { useHistoryStackTracker } from 'hooks/useHistoryStack';
import { ICustomRouterConfig } from 'interfaces/IRouterConfig';
import { RoutePath } from 'constants/RoutePath';
import { routerConfig } from './router-config';
import { AppLoader } from '../../shared/AppLoader/AppLoader';

const PrivateRoute = ({
  children, access, adminAccess, role, requiredRoles,
}) => {
  if (!adminAccess || adminAccess.includes(access)) {
    if (!requiredRoles || requiredRoles.includes(role)) {
      return children;
    }
  }

  return <Navigate to={RoutePath.ERROR} />;
};

const AppRouter = () => {
  const user = useSelector(userSelector);
  const access = useSelector(accessSelector);

  useHistoryStackTracker();

  const renderRoutes = useCallback((routerConfig: ICustomRouterConfig[]) => (
    routerConfig.map((route) => (
      <Route
        key={route.path}
        path={route.path}
        element={
          (
            <PrivateRoute
              requiredRoles={route.requiredRoles}
              adminAccess={route.adminAccess}
              role={user?.role}
              access={access}
            >
              {route.element}
            </PrivateRoute>
          )
        }
      >
        {route.children ? renderRoutes(route.children) : null}
      </Route>
    ))
  ), [access]);

  return (
    <Suspense fallback={<AppLoader />}>
      <Routes>
        {renderRoutes(routerConfig)}
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
